module.exports = __webpack_public_path__ + "img/item-3.16424c95.jpeg";